export * from './CommentRectIcon';
export * from './CommentRectIcon16Light';
export * from './CommentRectIcon16Regular';
export * from './CommentRectIcon16Solid';
export * from './CommentRectIcon20Light';
export * from './CommentRectIcon20Regular';
export * from './CommentRectIcon20Solid';
export * from './CommentRectIcon24Regular';
export * from './CommentRectIcon24Solid';
export * from './CommentRectIcon32Regular';
export * from './CommentRectIcon64Regular';
